import {
    GET_ALL_MUSEUMS,
    GET_ALL_MUSEUMS_SUCCESS,
    GET_ALL_MUSEUMS_FAIL,
    GET_MUSEUM_SUCCESS,
    GET_MUSEUM_FAIL,
    GET_MUSEUM,
    GET_TOP_MUSEUM,
    GET_TOP_MUSEUM_SUCCESS,
    GET_TOP_MUSEUM_FAIL,
    GET_TOP_ARTISTS,
    GET_TOP_ARTISTS_SUCCESS,
    GET_TOP_ARTISTS_FAIL,
    GET_ALL_ARTISTS,
    GET_ALL_ARTISTS_SUCCESS,
    GET_ALL_ARTISTS_FAIL
} from "./actionTypes";

/* Get all museums */
export const getALLMuseums = () => ({
    type: GET_ALL_MUSEUMS,
});
export const getALLMuseumsSuccess = (data) => ({
    type: GET_ALL_MUSEUMS_SUCCESS,
    payload: data,
});
export const getALLMuseumsFail = (error) => ({
    type: GET_ALL_MUSEUMS_FAIL,
    payload: error,
});

export const getTopMuseum = () => ({
    type: GET_TOP_MUSEUM,
});
export const getTopMuseumSuccess = (data) => ({
    type: GET_TOP_MUSEUM_SUCCESS,
    payload: data,
});
export const getTopMuseumFail = (error) => ({
    type: GET_TOP_MUSEUM_FAIL,
    payload: error,
});

export const getTopArtist1 = () => ({
    type: GET_TOP_ARTISTS,
});
export const getTopArtistSuccess = (data) => ({
    type: GET_TOP_ARTISTS_SUCCESS,
    payload: data,
});
export const getTopAtistFail = (error) => ({
    type: GET_TOP_ARTISTS_FAIL,
    payload: error,
});



export const getAllArtist = (data, callback) => ({
    type: GET_ALL_ARTISTS,
    payload:{data, callback}
});
export const getAllArtistSuccess = (data) => ({
    type: GET_ALL_ARTISTS_SUCCESS,
    payload: data,
});
export const getAllAtistFail = (error) => ({
    type: GET_ALL_ARTISTS_FAIL,
    payload: error,
});